var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-main"},[_c('div',{staticClass:"head"},[(_vm.$route.query.concise != 1)?_c('pageTitle',{attrs:{"pageTitle":"快问快答"}}):_vm._e(),_c('exam-table-panel',{ref:"examTable"})],1),(_vm.$route.query.type != 5 && _vm.webinarState != 4)?_c('begin-play',{attrs:{"webinarId":_vm.$route.params.str}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }